module.exports = __webpack_public_path__ + "static/media/baldursgate.54bfb8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/games/baldursgate.jpg
// module id = 26
// module chunks = 0